import React, {Component} from 'react';
import 'video.js/dist/video-js.css';
import '../../../assets/sass/components/video-player.scss';
import videojs from 'video.js';
import offset from 'videojs-offset';
import vjsdownload from 'videojs-vjsdownload';


window.videojs = videojs;

// offset plugin.
videojs.registerPlugin('offset', offset);

// vjsdownload plugin.
videojs.registerPlugin('vjsdownload', vjsdownload);


// resolution-switcher plugin.
require('videojs-youtube');
require("./videojs-resolution-switcher.css");
require("./videojs-resolution-switcher.js");


class VideoPlayer extends Component {
    videoPlayerConfig = () => {
        return {
            autoplay: true,
            controls: true,
            fluid: true,
            responsive: true,
            aspectRatio: '16:9',

            plugins: {
                videoJsResolutionSwitcher: {
                    default: 'low',
                    dynamicLabel: true,
                },
                offset: {
                    start: 0,
                    end: 60,
                },
                vjsdownload: {
                    beforeElement: 'playbackRateMenuButton',
                    textControl: 'Download video',
                    name: 'downloadButton',
                    // downloadURL: 'https://video_url.mp4' //optional if you need a different download url than the source
                }
            },

            controlBar: {
                pictureInPictureToggle: false,
                fullscreenToggle: true,
                currentTimeDisplay: true,
                timeDivider: true,
                durationDisplay: true,
                liveDisplay: true,
                chaptersButton: true,
                subtitlesButton: true,
                captionsButton: true,
                volumePanel: false,

                playToggle: {
                    replay: false,
                },
            },
            techOrder: ["youtube"],
            sources: [{"type": "video/youtube", "src": "https://www.youtube.com/watch?v=xjS6SftYQaQ"}],
            youtube: {"customVars": {"wmode": "transparent"}}
        };
    };

    componentDidMount() {
        let config = this.videoPlayerConfig();
        this.player = videojs(this.videoNode, config, function onPlayerReady() {
            let player = this;
            player.on('resolutionchange', function () {
                console.info('Source changed')
            });
        });

        let previous = this.player.controlBar.addChild('button', {
            style: {url: "assets/svg/actions/icn-download-video.svg"},
        });
        previous.addClass("vjs-icon-previous-item");

        let next = this.player.controlBar.addChild('button', {
            style: {url: "assets/svg/actions/icn-download-video.svg"},
        });
        next.addClass("vjs-icon-next-item");

        let screenShot = this.player.controlBar.addChild('button', {
            style: {url: "assets/svg/actions/icn-download-video.svg"},
        });
        screenShot.addClass("vjs-icon-screenshot-item");

        let downloadVideo = this.player.controlBar.addChild('button', {
            style: {url: "assets/svg/actions/icn-download-video.svg"},
        });
        downloadVideo.addClass("vjs-icon-download-video-item");

        let playButtonElement = this.player.controlBar.el().firstChild;
        this.player.controlBar.el().insertBefore(previous.el(), playButtonElement);
        this.player.controlBar.el().insertBefore(next.el(), playButtonElement.nextSibling);
        this.player.controlBar.el().append(screenShot.el());
        this.player.controlBar.el().append(downloadVideo.el());

        if (this.player) {
            const {src} = this.props;
            // this.player.src(src);
            if (config.autoplay) this.player.play();
        }
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (this.player) {
            const {src} = nextProps;
            this.player.src(src);
            this.player.play();
        }
    };

    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856

    // use `ref` to give Video JS a reference to the video DOM element: https://reactjs.org/docs/refs-and-the-dom
    render() {
        return (
            <video ref={node => this.videoNode = node} className="video-js vjs-fluid"
            />
        )
    }
}

export default VideoPlayer;
